<template>
    <CCard>
        <CCardHeader>
            Платное ожидание
            <RestaurantTableOrderBadge />
        </CCardHeader>
        <CCardBody>
            <slot name="tabs"></slot>
            <CForm>
                <div class="overflow-hidden border border-gray-300 rounded-md paid_waiting_form">
                    <div class="flex items-center bg-gray-100">
                        <div class="w-3/6 py-2 font-bold pl-2">Бесплатное ожидание (сек)</div>
                        <div class="w-3/6 py-2 font-bold">Стоимость ожидания (руб в мин)</div>
                    </div>

                    <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                        <div class="w-100 flex items-center">
                            <div class="w-3/6">
                                <CInput
                                    v-model.number="item.waiting_free_seconds"
                                    class="m-0 mr-2" />
                            </div>
                            <div class="w-3/6">
                                <CInput
                                    v-model.number="item.waiting_price_per_minute"
                                    class="m-0 mr-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </CForm>
        </CCardBody>
        <CCardFooter>
            <CButton
                color="primary"
                class="mr-3"
                @click="save"
            >Сохранить</CButton>
            <CButton
                v-if="item.entity_id !== null"
                color="danger"
                class="mr-3"
                @click="remove"
            >Сбросить к дефолтным настройкам</CButton>
        </CCardFooter>
    </CCard>
</template>

<script>
    export default {

        name: 'Delivery',

        props: {
            entityType: {
                type: String,
                default: ''
            },
            entityId: {
                type: Number,
                default: null
            },
        },
  
        data () {
            return {
                item: []
            }
        },

        computed: {
        },

        watch: {
        },

        mounted() {
            this.fetch();
        },
        
        methods: {
            async fetch() {
                this.item = (await this.axios.get(`/waiting-price/${this.entityType}/${this.entityId}`)).data;
            },
            
            async save() {
                this.isPending = true;
                try {
                    if(this.item.id && this.item.entity_id === this.entityId) {
                        await this.axios.put(`/waiting-price/${this.item.id}`, {
                            ...this.item,
                            entity_type: this.entityType,
                            entity_id: this.entityId,
                        });
                    } else {
                        await this.axios.post('/waiting-price', {
                            ...this.item,
                            entity_type: this.entityType,
                            entity_id: this.entityId,
                        });
                    } 
                    await this.fetch();
                } catch (error) {
                    this.$root.$emit('showError', 'Не удалось сохранить настройки' + error);
                }
                this.isPending = false;
            },
            
            async remove() {
                this.isPending = true;
                try {
                    await this.axios.delete(`/waiting-price/${this.item.id}`);
                    await this.fetch();
                } catch (error) {
                    this.$root.$emit('showError', 'Не удалось сохранить настройки' + error);
                }
                this.isPending = false;
            },
        }
    }
</script>
<style scoped>
.paid_waiting_form {
    position: relative;
}
</style>
